@if (languageData$ | async; as languageData) {
  <div class="input-group flex-nowrap">
    <span class="input-group-text">
      <i class="fa-solid fa-earth-europe"></i>
      <span class="mx-1"></span>
      <span>{{ 'shared.language' | translate }}</span>
    </span>
    <span>
      <button
        class="btn btn-outline-secondary dropdown-toggle"
        type="button"
        data-bs-toggle="dropdown">
        {{ languageData.currentLanguage?.name }}
      </button>
      <ul class="dropdown-menu">
        @for (lang of languageData.supportedLanguages; track lang) {
          <li>
            <a
              class="dropdown-item"
              tabindex="0"
              (keyup)="
                changeLanguageKey(
                  $event,
                  lang.code,
                  languageData.hasSession,
                  languageData.activeFormName,
                  languageData.activeFormLanguages,
                  languageData.currentLanguage?.code
                )
              "
              (click)="
                changeLanguage(
                  lang.code,
                  languageData.hasSession,
                  languageData.activeFormName,
                  languageData.activeFormLanguages,
                  languageData.currentLanguage?.code
                )
              ">
              {{ lang.name }}
            </a>
          </li>
        }
      </ul>
    </span>
  </div>
}
